import type { ReactNode } from 'react';

export interface CardProps {
  children: ReactNode;
  title?: string;
  compact?: boolean;
  className?: string;
}

export function Card({ children, title, compact = false, className = '' }: CardProps) {
  return (
    <div className={`card ${compact ? 'card-compact' : ''} ${className}`.trim()}>
      {title && <h2 className="card-header">{title}</h2>}
      {children}
    </div>
  );
}
